// import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useSidebarContext } from "../scenes/global/sidebar/SidebarContext";
// import { getDealersWithCommissions } from "../api";
// import {
//   Users,
//   Search,
//   DollarSign,
//   Phone,
//   Calendar,
//   Building,
//   MapPin,
//   RefreshCw,
//   Filter,
//   X,
//   ChevronDown,
//   ChevronUp,
//   TrendingUp,
//   FileText,
//   User,
//   CreditCard,
//   Eye,
//   ArrowUpDown,
// } from "lucide-react";
// import { useSnackbar } from "notistack";

// const CommissionDealers = () => {
//   const dispatch = useDispatch();
//   const { activeSociety, theme, gradient } = useSidebarContext();
//   const { enqueueSnackbar } = useSnackbar();
//   const [dealers, setDealers] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [refreshing, setRefreshing] = useState(false);
//   const [showFilters, setShowFilters] = useState(false);
//   const [sortBy, setSortBy] = useState("totalCommission");
//   const [sortOrder, setSortOrder] = useState("desc");
//   const [minCommission, setMinCommission] = useState("");
//   const [maxCommission, setMaxCommission] = useState("");
//   const [dateRange, setDateRange] = useState({ start: "", end: "" });
//   const [selectedDealer, setSelectedDealer] = useState(null);
//   const [showModal, setShowModal] = useState(false);

//   // Fetch dealers with commissions
//   const fetchDealers = async () => {
//     setLoading(true);
//     try {
//       const response = await getDealersWithCommissions(activeSociety?._id);
//       setDealers(response.dealers || []);
//     } catch (error) {
//       console.error("Error fetching dealers:", error);
//       enqueueSnackbar("Failed to fetch dealers", {
//         variant: "error",
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Refresh data
//   const handleRefresh = async () => {
//     setRefreshing(true);
//     await fetchDealers();
//     setRefreshing(false);
//     enqueueSnackbar("Data refreshed successfully", { variant: "success" });
//   };

//   // Load data when society changes
//   useEffect(() => {
//     if (activeSociety?._id) {
//       fetchDealers();
//     }
//   }, [activeSociety?._id]);

//   // Format currency
//   const formatCurrency = (amount) => {
//     if (!amount && amount !== 0) return "N/A";
//     return new Intl.NumberFormat("en-PK", {
//       style: "currency",
//       currency: "PKR",
//       minimumFractionDigits: 0,
//       maximumFractionDigits: 0,
//     }).format(amount);
//   };

//   // Format date
//   const formatDate = (dateString) => {
//     if (!dateString) return "N/A";
//     const date = new Date(dateString);
//     return date.toLocaleDateString("en-US", {
//       year: "numeric",
//       month: "short",
//       day: "numeric",
//     });
//   };

//   // Filter and sort dealers
//   const filteredAndSortedDealers = React.useMemo(() => {
//     let filtered = dealers.filter((dealer) => {
//       const searchLower = searchTerm.toLowerCase();
//       const matchesSearch =
//         dealer.dealerName?.toLowerCase().includes(searchLower) ||
//         dealer.dealerPhone?.includes(searchTerm);

//       const commission = dealer.totalCommission || 0;
//       const matchesMinCommission =
//         !minCommission || commission >= parseFloat(minCommission);
//       const matchesMaxCommission =
//         !maxCommission || commission <= parseFloat(maxCommission);

//       const matchesDateRange =
//         !dateRange.start ||
//         !dateRange.end ||
//         (dealer.firstBookingDate &&
//           new Date(dealer.firstBookingDate) >= new Date(dateRange.start) &&
//           new Date(dealer.firstBookingDate) <= new Date(dateRange.end));

//       return (
//         matchesSearch && matchesMinCommission && matchesMaxCommission && matchesDateRange
//       );
//     });

//     // Sort dealers
//     filtered.sort((a, b) => {
//       let aValue, bValue;
//       switch (sortBy) {
//         case "totalCommission":
//           aValue = a.totalCommission || 0;
//           bValue = b.totalCommission || 0;
//           break;
//         case "totalBookings":
//           aValue = a.totalBookings || 0;
//           bValue = b.totalBookings || 0;
//           break;
//         case "dealerName":
//           aValue = (a.dealerName || "").toLowerCase();
//           bValue = (b.dealerName || "").toLowerCase();
//           break;
//         default:
//           aValue = a.totalCommission || 0;
//           bValue = b.totalCommission || 0;
//       }

//       if (sortOrder === "asc") {
//         return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
//       } else {
//         return aValue < bValue ? 1 : aValue > bValue ? -1 : 0;
//       }
//     });

//     return filtered;
//   }, [dealers, searchTerm, sortBy, sortOrder, minCommission, maxCommission, dateRange]);

//   // Calculate totals
//   const totalCommission = filteredAndSortedDealers.reduce(
//     (sum, dealer) => sum + (dealer.totalCommission || 0),
//     0
//   );
//   const totalBookings = filteredAndSortedDealers.reduce(
//     (sum, dealer) => sum + (dealer.totalBookings || 0),
//     0
//   );

//   // Clear filters
//   const clearFilters = () => {
//     setSearchTerm("");
//     setMinCommission("");
//     setMaxCommission("");
//     setDateRange({ start: "", end: "" });
//     setSortBy("totalCommission");
//     setSortOrder("desc");
//   };

//   // Open modal with dealer details
//   const openDealerModal = (dealer) => {
//     setSelectedDealer(dealer);
//     setShowModal(true);
//   };

//   // Close modal
//   const closeModal = () => {
//     setShowModal(false);
//     setSelectedDealer(null);
//   };

//   return (
//     <div className="min-h-screen p-6 bg-gradient-to-br from-slate-800 via-slate-900 to-slate-800">
//       <div className="max-w-7xl mx-auto space-y-6">
//         {/* Header */}
//         <div className="bg-gradient-to-r from-slate-800 to-slate-900 rounded-2xl p-8 shadow-2xl border border-teal-500/20">
//           <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
//             <div className="flex-1">
//               <div className="flex items-center gap-3 mb-2">
//                 <div className="p-3 rounded-xl bg-teal-500/20 backdrop-blur-sm border border-teal-500/30">
//                   <Users className="w-8 h-8 text-teal-300" />
//                 </div>
//                 <h1 className="text-3xl md:text-4xl font-bold text-teal-300">
//                   Commission Dealers
//                 </h1>
//               </div>
//               <p className="text-sm text-teal-300/70 md:ml-16">
//                 Manage and track dealer commissions and bookings
//               </p>
//             </div>
//             <div className="flex items-center gap-3">
//               <button
//                 onClick={() => setShowFilters(!showFilters)}
//                 className={`flex items-center gap-2 px-6 py-3 rounded-xl transition-all shadow-lg backdrop-blur-sm border ${
//                   showFilters
//                     ? "bg-teal-500/30 border-teal-400/50"
//                     : "bg-teal-500/20 border-teal-500/30 hover:bg-teal-500/30"
//                 } text-teal-300`}
//               >
//                 <Filter className="w-5 h-5" />
//                 <span className="font-medium">Filters</span>
//               </button>
//               <button
//                 onClick={handleRefresh}
//                 disabled={refreshing || loading}
//                 className={`flex items-center gap-2 px-6 py-3 rounded-xl transition-all shadow-lg backdrop-blur-sm bg-teal-500/20 border border-teal-500/30 text-teal-300 ${
//                   refreshing || loading
//                     ? "opacity-50 cursor-not-allowed"
//                     : "hover:bg-teal-500/30 hover:scale-105"
//                 }`}
//               >
//                 <RefreshCw
//                   className={`w-5 h-5 ${refreshing ? "animate-spin" : ""}`}
//                 />
//                 <span className="font-medium">Refresh</span>
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Stats Cards */}
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//           <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-2xl p-6 shadow-xl hover:shadow-2xl transition-all hover:scale-105 border border-teal-500/20">
//             <div className="flex items-center gap-3 mb-3">
//               <Users className="w-6 h-6 text-teal-400" />
//               <div className="text-sm font-medium text-teal-300/80">
//                 Total Dealers
//               </div>
//             </div>
//             <div className="text-4xl font-bold text-teal-300 mb-2">
//               {filteredAndSortedDealers.length}
//             </div>
//             <div className="text-xs text-teal-300/60">
//               Active commission dealers
//             </div>
//           </div>
//           <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-2xl p-6 shadow-xl hover:shadow-2xl transition-all hover:scale-105 border border-teal-500/20">
//             <div className="flex items-center gap-3 mb-3">
//               <DollarSign className="w-6 h-6 text-teal-400" />
//               <div className="text-sm font-medium text-teal-300/80">
//                 Total Commission
//               </div>
//             </div>
//             <div className="text-3xl font-bold text-teal-300 mb-2">
//               {formatCurrency(totalCommission)}
//             </div>
//             <div className="text-xs text-teal-300/60">All time total</div>
//           </div>
//           <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-2xl p-6 shadow-xl hover:shadow-2xl transition-all hover:scale-105 border border-teal-500/20">
//             <div className="flex items-center gap-3 mb-3">
//               <FileText className="w-6 h-6 text-teal-400" />
//               <div className="text-sm font-medium text-teal-300/80">
//                 Total Bookings
//               </div>
//             </div>
//             <div className="text-4xl font-bold text-teal-300 mb-2">
//               {totalBookings}
//             </div>
//             <div className="text-xs text-teal-300/60">All dealer bookings</div>
//           </div>
//         </div>

//         {/* Search Bar */}
//         <div className="relative">
//           <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-teal-400" />
//           <input
//             type="text"
//             placeholder="Search by dealer name or phone..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="w-full pl-12 pr-4 py-4 rounded-xl border-2 border-teal-500/30 bg-slate-800/50 text-teal-300 placeholder-teal-300/40 focus:outline-none focus:ring-2 focus:ring-teal-500/50 focus:border-teal-500/50 transition-all shadow-lg"
//           />
//         </div>

//         {/* Filters Panel */}
//         {showFilters && (
//           <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-2xl p-6 shadow-xl border-2 border-teal-500/20">
//             <div className="flex items-center justify-between mb-4">
//               <h3 className="text-lg font-bold text-teal-300">
//                 Filter Options
//               </h3>
//               <button
//                 onClick={clearFilters}
//                 className="px-4 py-2 rounded-lg text-sm font-medium transition-all hover:scale-105 bg-teal-500/20 border border-teal-500/30 text-teal-300 hover:bg-teal-500/30"
//               >
//                 Clear All
//               </button>
//             </div>
//             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
//               <div>
//                 <label className="block text-sm font-medium mb-2 text-teal-300/80">
//                   Sort By
//                 </label>
//                 <select
//                   value={sortBy}
//                   onChange={(e) => setSortBy(e.target.value)}
//                   className="w-full px-4 py-2 rounded-lg border-2 border-teal-500/30 bg-slate-800/50 text-teal-300 focus:outline-none focus:ring-2 focus:ring-teal-500/50 transition-all"
//                 >
//                   <option value="totalCommission">Total Commission</option>
//                   <option value="totalBookings">Total Bookings</option>
//                   <option value="dealerName">Dealer Name</option>
//                 </select>
//               </div>
//               <div>
//                 <label className="block text-sm font-medium mb-2 text-teal-300/80">
//                   Order
//                 </label>
//                 <select
//                   value={sortOrder}
//                   onChange={(e) => setSortOrder(e.target.value)}
//                   className="w-full px-4 py-2 rounded-lg border-2 border-teal-500/30 bg-slate-800/50 text-teal-300 focus:outline-none focus:ring-2 focus:ring-teal-500/50 transition-all"
//                 >
//                   <option value="desc">Descending</option>
//                   <option value="asc">Ascending</option>
//                 </select>
//               </div>
//               <div>
//                 <label className="block text-sm font-medium mb-2 text-teal-300/80">
//                   Min Commission
//                 </label>
//                 <input
//                   type="number"
//                   value={minCommission}
//                   onChange={(e) => setMinCommission(e.target.value)}
//                   placeholder="0"
//                   className="w-full px-4 py-2 rounded-lg border-2 border-teal-500/30 bg-slate-800/50 text-teal-300 placeholder-teal-300/40 focus:outline-none focus:ring-2 focus:ring-teal-500/50 transition-all"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium mb-2 text-teal-300/80">
//                   Max Commission
//                 </label>
//                 <input
//                   type="number"
//                   value={maxCommission}
//                   onChange={(e) => setMaxCommission(e.target.value)}
//                   placeholder="No limit"
//                   className="w-full px-4 py-2 rounded-lg border-2 border-teal-500/30 bg-slate-800/50 text-teal-300 placeholder-teal-300/40 focus:outline-none focus:ring-2 focus:ring-teal-500/50 transition-all"
//                 />
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Dealers Table */}
//         {loading && filteredAndSortedDealers.length === 0 ? (
//           <div className="flex items-center justify-center py-20">
//             <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-teal-400"></div>
//           </div>
//         ) : filteredAndSortedDealers.length === 0 ? (
//           <div className="text-center py-20 rounded-lg bg-slate-800/50 border border-teal-500/20">
//             <Users className="w-16 h-16 mx-auto mb-4 opacity-50 text-teal-300/50" />
//             <p className="text-teal-300/70">No dealers found</p>
//           </div>
//         ) : (
//           <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-2xl shadow-2xl border border-teal-500/20 overflow-hidden">
//             <div className="overflow-x-auto">
//               <table className="w-full">
//                 <thead>
//                   <tr className="bg-slate-900/50 border-b border-teal-500/20">
//                     <th className="px-6 py-4 text-left text-sm font-semibold text-teal-300">
//                       <div className="flex items-center gap-2">
//                         <User className="w-4 h-4" />
//                         Dealer Name
//                       </div>
//                     </th>
//                     <th className="px-6 py-4 text-left text-sm font-semibold text-teal-300">
//                       <div className="flex items-center gap-2">
//                         <Phone className="w-4 h-4" />
//                         Contact
//                       </div>
//                     </th>
//                     <th className="px-6 py-4 text-left text-sm font-semibold text-teal-300">
//                       <div className="flex items-center gap-2">
//                         <DollarSign className="w-4 h-4" />
//                         Total Commission
//                       </div>
//                     </th>
//                     <th className="px-6 py-4 text-left text-sm font-semibold text-teal-300">
//                       <div className="flex items-center gap-2">
//                         <FileText className="w-4 h-4" />
//                         Bookings
//                       </div>
//                     </th>
//                     <th className="px-6 py-4 text-left text-sm font-semibold text-teal-300">
//                       <div className="flex items-center gap-2">
//                         <Calendar className="w-4 h-4" />
//                         First Booking
//                       </div>
//                     </th>
//                     <th className="px-6 py-4 text-center text-sm font-semibold text-teal-300">
//                       Actions
//                     </th>
//                   </tr>
//                 </thead>
//                 <tbody className="divide-y divide-teal-500/10">
//                   {filteredAndSortedDealers.map((dealer, index) => (
//                     <tr
//                       key={index}
//                       className="hover:bg-teal-500/5 transition-colors"
//                     >
//                       <td className="px-6 py-4">
//                         <div className="flex items-center gap-3">
//                           <div className="w-10 h-10 rounded-full bg-teal-500/20 flex items-center justify-center border border-teal-500/30">
//                             <User className="w-5 h-5 text-teal-400" />
//                           </div>
//                           <div className="font-semibold text-teal-300">
//                             {dealer.dealerName || "N/A"}
//                           </div>
//                         </div>
//                       </td>
//                       <td className="px-6 py-4">
//                         <div className="text-teal-300/80">
//                           {dealer.dealerPhone || "N/A"}
//                         </div>
//                       </td>
//                       <td className="px-6 py-4">
//                         <div className="font-bold text-teal-400">
//                           {formatCurrency(dealer.totalCommission || 0)}
//                         </div>
//                       </td>
//                       <td className="px-6 py-4">
//                         <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-teal-500/20 border border-teal-500/30">
//                           <span className="text-teal-300 font-semibold">
//                             {dealer.totalBookings || 0}
//                           </span>
//                         </div>
//                       </td>
//                       <td className="px-6 py-4">
//                         <div className="text-teal-300/80">
//                           {formatDate(dealer.firstBookingDate)}
//                         </div>
//                       </td>
//                       <td className="px-6 py-4">
//                         <div className="flex items-center justify-center gap-2">
//                           {dealer.bookings && dealer.bookings.length > 0 && (
//                             <button
//                               onClick={() => openDealerModal(dealer)}
//                               className="flex items-center gap-2 px-4 py-2 rounded-lg bg-teal-500/20 border border-teal-500/30 text-teal-300 hover:bg-teal-500/30 transition-all hover:scale-105"
//                             >
//                               <Eye className="w-4 h-4" />
//                               View Details
//                             </button>
//                           )}
//                         </div>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* Modal */}
//       {showModal && selectedDealer && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
//           <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-2xl shadow-2xl border-2 border-teal-500/30 max-w-5xl w-full max-h-[90vh] overflow-hidden">
//             {/* Modal Header */}
//             <div className="flex items-center justify-between p-6 border-b border-teal-500/20 bg-slate-900/50">
//               <div className="flex items-center gap-3">
//                 <div className="p-3 rounded-xl bg-teal-500/20 border border-teal-500/30">
//                   <User className="w-6 h-6 text-teal-400" />
//                 </div>
//                 <div>
//                   <h2 className="text-2xl font-bold text-teal-300">
//                     {selectedDealer.dealerName || "N/A"}
//                   </h2>
//                   <p className="text-sm text-teal-300/70">
//                     {selectedDealer.dealerPhone || "No phone"}
//                   </p>
//                 </div>
//               </div>
//               <button
//                 onClick={closeModal}
//                 className="p-2 rounded-lg hover:bg-teal-500/20 transition-colors text-teal-300"
//               >
//                 <X className="w-6 h-6" />
//               </button>
//             </div>

//             {/* Modal Body */}
//             <div className="p-6 overflow-y-auto max-h-[calc(90vh-180px)] custom-scrollbar">
//               {/* Summary Stats */}
//               <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
//                 <div className="bg-slate-900/50 rounded-xl p-4 border border-teal-500/20">
//                   <div className="flex items-center gap-2 mb-2">
//                     <DollarSign className="w-5 h-5 text-teal-400" />
//                     <span className="text-sm font-medium text-teal-300/80">
//                       Total Commission
//                     </span>
//                   </div>
//                   <div className="text-2xl font-bold text-teal-300">
//                     {formatCurrency(selectedDealer.totalCommission || 0)}
//                   </div>
//                 </div>
//                 <div className="bg-slate-900/50 rounded-xl p-4 border border-teal-500/20">
//                   <div className="flex items-center gap-2 mb-2">
//                     <FileText className="w-5 h-5 text-teal-400" />
//                     <span className="text-sm font-medium text-teal-300/80">
//                       Total Bookings
//                     </span>
//                   </div>
//                   <div className="text-2xl font-bold text-teal-300">
//                     {selectedDealer.totalBookings || 0}
//                   </div>
//                 </div>
//                 <div className="bg-slate-900/50 rounded-xl p-4 border border-teal-500/20">
//                   <div className="flex items-center gap-2 mb-2">
//                     <Calendar className="w-5 h-5 text-teal-400" />
//                     <span className="text-sm font-medium text-teal-300/80">
//                       First Booking
//                     </span>
//                   </div>
//                   <div className="text-sm font-semibold text-teal-300">
//                     {formatDate(selectedDealer.firstBookingDate)}
//                   </div>
//                 </div>
//               </div>

//               {/* Bookings List */}
//               <h3 className="text-lg font-bold text-teal-300 mb-4">
//                 Booking Details ({selectedDealer.bookings?.length || 0})
//               </h3>
//               <div className="space-y-4">
//                 {selectedDealer.bookings?.map((booking, bookingIndex) => (
//                   <div
//                     key={bookingIndex}
//                     className="bg-slate-900/30 rounded-xl p-5 border border-teal-500/20 hover:border-teal-500/40 transition-all"
//                   >
//                     <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
//                       <div>
//                         <div className="text-xs font-medium mb-1 text-teal-300/60">
//                           Booking Number
//                         </div>
//                         <div className="text-sm font-bold text-teal-300">
//                           {booking.bookingNumber || "N/A"}
//                         </div>
//                       </div>
//                       <div>
//                         <div className="text-xs font-medium mb-1 text-teal-300/60">
//                           Commission
//                         </div>
//                         <div className="text-sm font-bold text-teal-400">
//                           {formatCurrency(booking.commission || 0)}
//                         </div>
//                       </div>
// <div>
//   <div className="text-xs font-medium mb-1 text-teal-300/60">
//     Plot Details
//   </div>
//   <div className="flex items-center gap-1">
//     <MapPin className="w-4 h-4 text-teal-400" />
//     <span className="text-sm font-semibold text-teal-300">
//       {booking.plot?.plotNumber || "N/A"}
//     </span>
//   </div>
//   {booking.plot?.block && (
//     <div className="text-xs text-teal-300/60">
//       Block: {booking.plot.block}
//     </div>
//   )}
// </div>
//                       <div>
//                         <div className="text-xs font-medium mb-1 text-teal-300/60">
//                           Customer
//                         </div>
//                         <div className="flex items-center gap-1">
//                           <User className="w-4 h-4 text-teal-400" />
//                           <span className="text-sm font-semibold text-teal-300">
//                             {booking.customer?.name || "N/A"}
//                           </span>
//                         </div>
//                       </div>
//                     </div>
//                     {booking.commissionDate && (
//                       <div className="mt-4 pt-4 border-t border-teal-500/10">
//                         <div className="flex items-center gap-2 text-xs text-teal-300/60">
//                           <Calendar className="w-3 h-3" />
//                           <span>
//                             Commission Date: {formatDate(booking.commissionDate)}
//                           </span>
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                 ))}
//               </div>
//             </div>

//             {/* Modal Footer */}
//             <div className="flex items-center justify-end gap-3 p-6 border-t border-teal-500/20 bg-slate-900/50">
//               <button
//                 onClick={closeModal}
//                 className="px-6 py-3 rounded-xl bg-teal-500/20 border border-teal-500/30 text-teal-300 hover:bg-teal-500/30 transition-all font-medium"
//               >
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       <style
//         dangerouslySetInnerHTML={{
//           __html: `
//             .custom-scrollbar::-webkit-scrollbar {
//               width: 8px;
//             }
//             .custom-scrollbar::-webkit-scrollbar-track {
//               background: rgba(20, 184, 166, 0.1);
//               border-radius: 10px;
//             }
//             .custom-scrollbar::-webkit-scrollbar-thumb {
//               background: rgba(20, 184, 166, 0.3);
//               border-radius: 10px;
//             }
//             .custom-scrollbar::-webkit-scrollbar-thumb:hover {
//               background: rgba(20, 184, 166, 0.5);
//             }
//           `,
//         }}
//       />
//     </div>
//   );
// };

// export default CommissionDealers;


import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSidebarContext } from "../scenes/global/sidebar/SidebarContext";
import { getDealersWithCommissions } from "../api";
import {
  Users,
  Search,
  DollarSign,
  Phone,
  Calendar,
  Building,
  MapPin,
  RefreshCw,
  Filter,
  X,
  ChevronDown,
  ChevronUp,
  TrendingUp,
  FileText,
  User,
  CreditCard,
  Eye,
  ArrowUpDown,
  ChevronLeft,
  ChevronRight,
} from "lucide-react";
import { useSnackbar } from "notistack";

const CommissionDealers = () => {
  const dispatch = useDispatch();
  const { activeSociety, theme, gradient } = useSidebarContext();
  const { enqueueSnackbar } = useSnackbar();
  const [dealers, setDealers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [refreshing, setRefreshing] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [sortBy, setSortBy] = useState("totalCommission");
  const [sortOrder, setSortOrder] = useState("desc");
  const [minCommission, setMinCommission] = useState("");
  const [maxCommission, setMaxCommission] = useState("");
  const [dateRange, setDateRange] = useState({ start: "", end: "" });
  const [selectedDealer, setSelectedDealer] = useState(null);
  const [showModal, setShowModal] = useState(false);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Fetch dealers with commissions
  const fetchDealers = async () => {
    setLoading(true);
    try {
      const response = await getDealersWithCommissions(activeSociety?._id);
      setDealers(response.dealers || []);
    } catch (error) {
      console.error("Error fetching dealers:", error);
      enqueueSnackbar("Failed to fetch dealers", {
        variant: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  // Refresh data
  const handleRefresh = async () => {
    setRefreshing(true);
    await fetchDealers();
    setRefreshing(false);
    enqueueSnackbar("Data refreshed successfully", { variant: "success" });
  };

  // Load data when society changes
  useEffect(() => {
    if (activeSociety?._id) {
      fetchDealers();
    }
  }, [activeSociety?._id]);

  // Format currency
  const formatCurrency = (amount) => {
    if (!amount && amount !== 0) return "N/A";
    return new Intl.NumberFormat("en-PK", {
      style: "currency",
      currency: "PKR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  // Filter and sort dealers
  const filteredAndSortedDealers = React.useMemo(() => {
    let filtered = dealers.filter((dealer) => {
      const searchLower = searchTerm.toLowerCase();
      const matchesSearch =
        dealer.dealerName?.toLowerCase().includes(searchLower) ||
        dealer.dealerPhone?.includes(searchTerm);

      const commission = dealer.totalCommission || 0;
      const matchesMinCommission =
        !minCommission || commission >= parseFloat(minCommission);
      const matchesMaxCommission =
        !maxCommission || commission <= parseFloat(maxCommission);

      const matchesDateRange =
        !dateRange.start ||
        !dateRange.end ||
        (dealer.firstBookingDate &&
          new Date(dealer.firstBookingDate) >= new Date(dateRange.start) &&
          new Date(dealer.firstBookingDate) <= new Date(dateRange.end));

      return (
        matchesSearch && matchesMinCommission && matchesMaxCommission && matchesDateRange
      );
    });

    // Sort dealers
    filtered.sort((a, b) => {
      let aValue, bValue;
      switch (sortBy) {
        case "totalCommission":
          aValue = a.totalCommission || 0;
          bValue = b.totalCommission || 0;
          break;
        case "totalBookings":
          aValue = a.totalBookings || 0;
          bValue = b.totalBookings || 0;
          break;
        case "dealerName":
          aValue = (a.dealerName || "").toLowerCase();
          bValue = (b.dealerName || "").toLowerCase();
          break;
        default:
          aValue = a.totalCommission || 0;
          bValue = b.totalCommission || 0;
      }

      if (sortOrder === "asc") {
        return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
      } else {
        return aValue < bValue ? 1 : aValue > bValue ? -1 : 0;
      }
    });

    return filtered;
  }, [dealers, searchTerm, sortBy, sortOrder, minCommission, maxCommission, dateRange]);

  // Calculate totals
  const totalCommission = filteredAndSortedDealers.reduce(
    (sum, dealer) => sum + (dealer.totalCommission || 0),
    0
  );
  const totalBookings = filteredAndSortedDealers.reduce(
    (sum, dealer) => sum + (dealer.totalBookings || 0),
    0
  );

  // Pagination calculations
  const totalPages = Math.ceil(filteredAndSortedDealers.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentDealers = filteredAndSortedDealers.slice(startIndex, endIndex);

  // Reset to page 1 when filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, sortBy, sortOrder, minCommission, maxCommission, dateRange]);

  // Clear filters
  const clearFilters = () => {
    setSearchTerm("");
    setMinCommission("");
    setMaxCommission("");
    setDateRange({ start: "", end: "" });
    setSortBy("totalCommission");
    setSortOrder("desc");
  };

  // Open modal with dealer details
  const openDealerModal = (dealer) => {
    setSelectedDealer(dealer);
    setShowModal(true);
  };

  // Close modal
  const closeModal = () => {
    setShowModal(false);
    setSelectedDealer(null);
  };

  // Pagination handlers
  const goToPage = (page) => {
    setCurrentPage(page);
  };

  const goToPrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const goToNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    <div className="min-h-screen p-3 sm:p-6 bg-gradient-to-br from-slate-800 via-slate-900 to-slate-800">
      <div className="max-w-7xl mx-auto space-y-4 sm:space-y-6">
        {/* Header */}
        <div className="bg-gradient-to-r from-slate-800 to-slate-900 rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-2xl border border-teal-500/20">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 sm:gap-4">
            <div className="flex-1">
              <div className="flex items-center gap-2 sm:gap-3 mb-2">
                <div className="p-2 sm:p-3 rounded-lg sm:rounded-xl bg-teal-500/20 backdrop-blur-sm border border-teal-500/30">
                  <Users className="w-5 h-5 sm:w-6 sm:h-6 text-teal-300" />
                </div>
                <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-teal-300">
                  Commission Dealers
                </h1>
              </div>
              <p className="text-xs sm:text-sm text-teal-300/70 sm:ml-12">
                Manage and track dealer commissions
              </p>
            </div>
            <div className="flex items-center gap-2 sm:gap-3 w-full sm:w-auto">
              <button
                onClick={() => setShowFilters(!showFilters)}
                className={`flex items-center gap-2 px-3 sm:px-4 py-2 sm:py-2.5 rounded-lg sm:rounded-xl transition-all shadow-lg backdrop-blur-sm border text-sm ${showFilters
                  ? "bg-teal-500/30 border-teal-400/50"
                  : "bg-teal-500/20 border-teal-500/30 hover:bg-teal-500/30"
                  } text-teal-300 flex-1 sm:flex-none justify-center`}
              >
                <Filter className="w-4 h-4" />
                <span className="font-medium">Filters</span>
              </button>
              <button
                onClick={handleRefresh}
                disabled={refreshing || loading}
                className={`flex items-center gap-2 px-3 sm:px-4 py-2 sm:py-2.5 rounded-lg sm:rounded-xl transition-all shadow-lg backdrop-blur-sm bg-teal-500/20 border border-teal-500/30 text-teal-300 text-sm flex-1 sm:flex-none justify-center ${refreshing || loading
                  ? "opacity-50 cursor-not-allowed"
                  : "hover:bg-teal-500/30 hover:scale-105"
                  }`}
              >
                <RefreshCw
                  className={`w-4 h-4 ${refreshing ? "animate-spin" : ""}`}
                />
                <span className="font-medium">Refresh</span>
              </button>
            </div>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-3 gap-2 sm:gap-4">
          <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-lg sm:rounded-xl p-3 sm:p-4 shadow-xl hover:shadow-2xl transition-all hover:scale-105 border border-teal-500/20">
            <div className="flex flex-col gap-1 sm:gap-2">
              <Users className="w-4 h-4 sm:w-5 sm:h-5 text-teal-400" />
              <div className="text-lg sm:text-2xl md:text-3xl font-bold text-teal-300">
                {filteredAndSortedDealers.length}
              </div>
              <div className="text-[10px] sm:text-xs text-teal-300/60">
                Dealers
              </div>
            </div>
          </div>
          <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-lg sm:rounded-xl p-3 sm:p-4 shadow-xl hover:shadow-2xl transition-all hover:scale-105 border border-teal-500/20">
            <div className="flex flex-col gap-1 sm:gap-2">
              <DollarSign className="w-4 h-4 sm:w-5 sm:h-5 text-teal-400" />
              <div className="text-xs sm:text-lg md:text-xl font-bold text-teal-300">
                {formatCurrency(totalCommission).replace('PKR', '₨')}
              </div>
              <div className="text-[10px] sm:text-xs text-teal-300/60">
                Commission
              </div>
            </div>
          </div>
          <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-lg sm:rounded-xl p-3 sm:p-4 shadow-xl hover:shadow-2xl transition-all hover:scale-105 border border-teal-500/20">
            <div className="flex flex-col gap-1 sm:gap-2">
              <FileText className="w-4 h-4 sm:w-5 sm:h-5 text-teal-400" />
              <div className="text-lg sm:text-2xl md:text-3xl font-bold text-teal-300">
                {totalBookings}
              </div>
              <div className="text-[10px] sm:text-xs text-teal-300/60">
                Bookings
              </div>
            </div>
          </div>
        </div>

        {/* Search Bar */}
        <div className="relative">
          <Search className="absolute left-3 sm:left-4 top-1/2 transform -translate-y-1/2 w-4 h-4 sm:w-5 sm:h-5 text-teal-400" />
          <input
            type="text"
            placeholder="Search by dealer name or phone..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-10 sm:pl-12 pr-4 py-3 sm:py-4 rounded-lg sm:rounded-xl border-2 border-teal-500/30 bg-slate-800/50 text-teal-300 placeholder-teal-300/40 focus:outline-none focus:ring-2 focus:ring-teal-500/50 focus:border-teal-500/50 transition-all shadow-lg text-sm sm:text-base"
          />
        </div>

        {/* Filters Panel */}
        {showFilters && (
          <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-xl border-2 border-teal-500/20">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-base sm:text-lg font-bold text-teal-300">
                Filter Options
              </h3>
              <button
                onClick={clearFilters}
                className="px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg text-xs sm:text-sm font-medium transition-all hover:scale-105 bg-teal-500/20 border border-teal-500/30 text-teal-300 hover:bg-teal-500/30"
              >
                Clear All
              </button>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
              <div>
                <label className="block text-xs sm:text-sm font-medium mb-2 text-teal-300/80">
                  Sort By
                </label>
                <select
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)}
                  className="w-full px-3 sm:px-4 py-2 rounded-lg border-2 border-teal-500/30 bg-slate-800/50 text-teal-300 focus:outline-none focus:ring-2 focus:ring-teal-500/50 transition-all text-sm"
                >
                  <option value="totalCommission">Total Commission</option>
                  <option value="totalBookings">Total Bookings</option>
                  <option value="dealerName">Dealer Name</option>
                </select>
              </div>
              <div>
                <label className="block text-xs sm:text-sm font-medium mb-2 text-teal-300/80">
                  Order
                </label>
                <select
                  value={sortOrder}
                  onChange={(e) => setSortOrder(e.target.value)}
                  className="w-full px-3 sm:px-4 py-2 rounded-lg border-2 border-teal-500/30 bg-slate-800/50 text-teal-300 focus:outline-none focus:ring-2 focus:ring-teal-500/50 transition-all text-sm"
                >
                  <option value="desc">Descending</option>
                  <option value="asc">Ascending</option>
                </select>
              </div>
              <div>
                <label className="block text-xs sm:text-sm font-medium mb-2 text-teal-300/80">
                  Min Commission
                </label>
                <input
                  type="number"
                  value={minCommission}
                  onChange={(e) => setMinCommission(e.target.value)}
                  placeholder="0"
                  className="w-full px-3 sm:px-4 py-2 rounded-lg border-2 border-teal-500/30 bg-slate-800/50 text-teal-300 placeholder-teal-300/40 focus:outline-none focus:ring-2 focus:ring-teal-500/50 transition-all text-sm"
                />
              </div>
              <div>
                <label className="block text-xs sm:text-sm font-medium mb-2 text-teal-300/80">
                  Max Commission
                </label>
                <input
                  type="number"
                  value={maxCommission}
                  onChange={(e) => setMaxCommission(e.target.value)}
                  placeholder="No limit"
                  className="w-full px-3 sm:px-4 py-2 rounded-lg border-2 border-teal-500/30 bg-slate-800/50 text-teal-300 placeholder-teal-300/40 focus:outline-none focus:ring-2 focus:ring-teal-500/50 transition-all text-sm"
                />
              </div>
            </div>
          </div>
        )}

        {/* Dealers Table */}
        {loading && filteredAndSortedDealers.length === 0 ? (
          <div className="flex items-center justify-center py-20">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-teal-400"></div>
          </div>
        ) : filteredAndSortedDealers.length === 0 ? (
          <div className="text-center py-20 rounded-lg bg-slate-800/50 border border-teal-500/20">
            <Users className="w-16 h-16 mx-auto mb-4 opacity-50 text-teal-300/50" />
            <p className="text-teal-300/70">No dealers found</p>
          </div>
        ) : (
          <>
            <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-xl sm:rounded-2xl shadow-2xl border border-teal-500/20 overflow-hidden">
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead>
                    <tr className="bg-slate-900/50 border-b border-teal-500/20">
                      <th className="px-3 sm:px-6 py-3 sm:py-4 text-left text-xs sm:text-sm font-semibold text-teal-300">
                        <div className="flex items-center gap-2">
                          <User className="w-3 h-3 sm:w-4 sm:h-4" />
                          <span className="hidden sm:inline">Dealer Name</span>
                          <span className="sm:hidden">Name</span>
                        </div>
                      </th>
                      <th className="px-3 sm:px-6 py-3 sm:py-4 text-left text-xs sm:text-sm font-semibold text-teal-300">
                        <div className="flex items-center gap-2">
                          <Phone className="w-3 h-3 sm:w-4 sm:h-4" />
                          <span className="hidden sm:inline">Contact</span>
                        </div>
                      </th>
                      <th className="px-3 sm:px-6 py-3 sm:py-4 text-left text-xs sm:text-sm font-semibold text-teal-300">
                        <div className="flex items-center gap-2">
                          <DollarSign className="w-3 h-3 sm:w-4 sm:h-4" />
                          <span className="hidden md:inline">Commission</span>
                        </div>
                      </th>
                      <th className="px-3 sm:px-6 py-3 sm:py-4 text-left text-xs sm:text-sm font-semibold text-teal-300">
                        <div className="flex items-center gap-2">
                          <FileText className="w-3 h-3 sm:w-4 sm:h-4" />
                          <span className="hidden lg:inline">Bookings</span>
                        </div>
                      </th>
                      <th className="px-3 sm:px-6 py-3 sm:py-4 text-left text-xs sm:text-sm font-semibold text-teal-300 hidden lg:table-cell">
                        <div className="flex items-center gap-2">
                          <Calendar className="w-3 h-3 sm:w-4 sm:h-4" />
                          First Booking
                        </div>
                      </th>
                      <th className="px-3 sm:px-6 py-3 sm:py-4 text-center text-xs sm:text-sm font-semibold text-teal-300">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-teal-500/10">
                    {currentDealers.map((dealer, index) => (
                      <tr
                        key={index}
                        className="hover:bg-teal-500/5 transition-colors"
                      >
                        <td className="px-3 sm:px-6 py-3 sm:py-4">
                          <div className="flex items-center gap-2 sm:gap-3">
                            <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-teal-500/20 flex items-center justify-center border border-teal-500/30 flex-shrink-0">
                              <User className="w-4 h-4 sm:w-5 sm:h-5 text-teal-400" />
                            </div>
                            <div className="font-semibold text-teal-300 text-xs sm:text-sm truncate">
                              {dealer.dealerName || "N/A"}
                            </div>
                          </div>
                        </td>
                        <td className="px-3 sm:px-6 py-3 sm:py-4">
                          <div className="text-teal-300/80 text-xs sm:text-sm">
                            {dealer.dealerPhone || "N/A"}
                          </div>
                        </td>
                        <td className="px-3 sm:px-6 py-3 sm:py-4">
                          <div className="font-bold text-teal-400 text-xs sm:text-sm">
                            {formatCurrency(dealer.totalCommission || 0).replace('PKR', '₨')}
                          </div>
                        </td>
                        <td className="px-3 sm:px-6 py-3 sm:py-4">
                          <div className="inline-flex items-center gap-2 px-2 sm:px-3 py-1 rounded-full bg-teal-500/20 border border-teal-500/30">
                            <span className="text-teal-300 font-semibold text-xs sm:text-sm">
                              {dealer.totalBookings || 0}
                            </span>
                          </div>
                        </td>
                        <td className="px-3 sm:px-6 py-3 sm:py-4 hidden lg:table-cell">
                          <div className="text-teal-300/80 text-xs sm:text-sm">
                            {formatDate(dealer.firstBookingDate)}
                          </div>
                        </td>
                        <td className="px-3 sm:px-6 py-3 sm:py-4">
                          <div className="flex items-center justify-center gap-2">
                            {dealer.bookings && dealer.bookings.length > 0 && (
                              <button
                                onClick={() => openDealerModal(dealer)}
                                className="flex items-center gap-1 sm:gap-2 px-2 sm:px-4 py-1.5 sm:py-2 rounded-lg bg-teal-500/20 border border-teal-500/30 text-teal-300 hover:bg-teal-500/30 transition-all hover:scale-105 text-xs sm:text-sm"
                              >
                                <Eye className="w-3 h-3 sm:w-4 sm:h-4" />
                                <span className="hidden sm:inline">View</span>
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-4 bg-gradient-to-br from-slate-800 to-slate-900 rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-xl border border-teal-500/20">
                <div className="text-xs sm:text-sm text-teal-300/70">
                  Showing {startIndex + 1} to {Math.min(endIndex, filteredAndSortedDealers.length)} of {filteredAndSortedDealers.length} dealers
                </div>
                <div className="flex items-center gap-2">
                  <button
                    onClick={goToPrevious}
                    disabled={currentPage === 1}
                    className={`p-2 rounded-lg border border-teal-500/30 transition-all ${currentPage === 1
                      ? "bg-slate-800/50 text-teal-300/30 cursor-not-allowed"
                      : "bg-teal-500/20 text-teal-300 hover:bg-teal-500/30"
                      }`}
                  >
                    <ChevronLeft className="w-4 h-4 sm:w-5 sm:h-5" />
                  </button>

                  <div className="flex items-center gap-1 sm:gap-2">
                    {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => {
                      // Show first page, last page, current page, and pages around current
                      if (
                        page === 1 ||
                        page === totalPages ||
                        (page >= currentPage - 1 && page <= currentPage + 1)
                      ) {
                        return (
                          <button
                            key={page}
                            onClick={() => goToPage(page)}
                            className={`w-8 h-8 sm:w-10 sm:h-10 rounded-lg border transition-all text-xs sm:text-sm font-medium ${currentPage === page
                              ? "bg-teal-500/30 border-teal-400/50 text-teal-300"
                              : "bg-teal-500/10 border-teal-500/30 text-teal-300/70 hover:bg-teal-500/20"
                              }`}
                          >
                            {page}
                          </button>
                        );
                      } else if (
                        page === currentPage - 2 ||
                        page === currentPage + 2
                      ) {
                        return (
                          <span key={page} className="text-teal-300/50 px-1">
                            ...
                          </span>
                        );
                      }
                      return null;
                    })}
                  </div>

                  <button
                    onClick={goToNext}
                    disabled={currentPage === totalPages}
                    className={`p-2 rounded-lg border border-teal-500/30 transition-all ${currentPage === totalPages
                      ? "bg-slate-800/50 text-teal-300/30 cursor-not-allowed"
                      : "bg-teal-500/20 text-teal-300 hover:bg-teal-500/30"
                      }`}
                  >
                    <ChevronRight className="w-4 h-4 sm:w-5 sm:h-5" />
                  </button>
                </div>
              </div>
            )}
          </>
        )}
      </div>

      {/* Modal - Full Screen Overlay */}
      {showModal && selectedDealer && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center p-2 sm:p-4 bg-black/70 backdrop-blur-md">
          <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-xl sm:rounded-2xl shadow-2xl border-2 border-teal-500/30 w-full max-w-5xl max-h-[95vh] sm:max-h-[90vh] overflow-hidden flex flex-col">
            {/* Modal Header */}
            <div className="flex items-center justify-between p-4 sm:p-6 border-b border-teal-500/20 bg-slate-900/50 flex-shrink-0">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-teal-500/20 flex items-center justify-center border border-teal-500/30">
                  <User className="w-5 h-5 sm:w-6 sm:h-6 text-teal-400" />
                </div>
                <div>
                  <h2 className="text-lg sm:text-xl font-bold text-teal-300">
                    {selectedDealer.dealerName || "N/A"}
                  </h2>
                  <p className="text-xs sm:text-sm text-teal-300/70">
                    Dealer Details & Bookings
                  </p>
                </div>
              </div>
              <button
                onClick={closeModal}
                className="p-2 rounded-lg bg-teal-500/20 border border-teal-500/30 text-teal-300 hover:bg-teal-500/30 transition-all"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            {/* Modal Body - Scrollable */}
            <div className="flex-1 overflow-y-auto p-4 sm:p-6">
              {/* Dealer Info Grid */}
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 mb-6">
                <div className="bg-slate-900/50 rounded-lg p-3 sm:p-4 border border-teal-500/20">
                  <div className="flex items-center gap-2 mb-2">
                    <Phone className="w-4 h-4 text-teal-400" />
                    <span className="text-xs text-teal-300/70">Phone</span>
                  </div>
                  <p className="text-sm sm:text-base font-semibold text-teal-300">
                    {selectedDealer.dealerPhone || "N/A"}
                  </p>
                </div>
                <div className="bg-slate-900/50 rounded-lg p-3 sm:p-4 border border-teal-500/20">
                  <div className="flex items-center gap-2 mb-2">
                    <DollarSign className="w-4 h-4 text-teal-400" />
                    <span className="text-xs text-teal-300/70">Total Commission</span>
                  </div>
                  <p className="text-sm sm:text-base font-bold text-teal-400">
                    {formatCurrency(selectedDealer.totalCommission || 0).replace('PKR', '₨')}
                  </p>
                </div>
                <div className="bg-slate-900/50 rounded-lg p-3 sm:p-4 border border-teal-500/20">
                  <div className="flex items-center gap-2 mb-2">
                    <FileText className="w-4 h-4 text-teal-400" />
                    <span className="text-xs text-teal-300/70">Total Bookings</span>
                  </div>
                  <p className="text-sm sm:text-base font-bold text-teal-300">
                    {selectedDealer.totalBookings || 0}
                  </p>
                </div>
                <div className="bg-slate-900/50 rounded-lg p-3 sm:p-4 border border-teal-500/20">
                  <div className="flex items-center gap-2 mb-2">
                    <Calendar className="w-4 h-4 text-teal-400" />
                    <span className="text-xs text-teal-300/70">First Booking</span>
                  </div>
                  <p className="text-sm sm:text-base font-semibold text-teal-300">
                    {formatDate(selectedDealer.firstBookingDate)}
                  </p>
                </div>
                <div className="bg-slate-900/50 rounded-lg p-3 sm:p-4 border border-teal-500/20">
                  <div className="flex items-center gap-2 mb-2">
                    <Calendar className="w-4 h-4 text-teal-400" />
                    <span className="text-xs text-teal-300/70">Last Booking</span>
                  </div>
                  <p className="text-sm sm:text-base font-semibold text-teal-300">
                    {formatDate(selectedDealer.lastBookingDate)}
                  </p>
                </div>
              </div>

              {/* Bookings List */}
              <div>
                <h3 className="text-base sm:text-lg font-bold text-teal-300 mb-3 sm:mb-4">
                  Booking History ({selectedDealer.bookings?.length || 0})
                </h3>
                <div className="space-y-3">
                  {selectedDealer.bookings && selectedDealer.bookings.length > 0 ? (
                    selectedDealer.bookings.map((booking, idx) => (
                      <div
                        key={idx}
                        className="bg-slate-900/50 rounded-lg p-3 sm:p-4 border border-teal-500/20 hover:border-teal-500/40 transition-all"
                      >
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-3">
                          <div>
                            <div className="text-xs font-medium mb-1 text-teal-300/60">
                              Plot Details
                            </div>
                            <div className="flex items-center gap-1">
                              <MapPin className="w-4 h-4 text-teal-400" />
                              <span className="text-sm font-semibold text-teal-300">
                                {booking.plot?.plotNumber || "N/A"}
                              </span>
                            </div>
                            {booking.plot?.block && (
                              <div className="text-xs text-teal-300/60">
                                Block: {booking.plot.block}
                              </div>
                            )}
                          </div>
                          <div>
                            <span className="text-xs text-teal-300/70">Customer</span>
                            <p className="text-sm font-semibold text-teal-300 mt-1">
                              {booking.customer?.name || "N/A"}
                            </p>
                          </div>
                          <div>
                            <span className="text-xs text-teal-300/70">Commission</span>
                            <p className="text-sm font-bold text-teal-400 mt-1">
                              {formatCurrency(booking.commission || 0).replace('PKR', '₨')}
                            </p>
                          </div>
                          <div>
                            <span className="text-xs text-teal-300/70">Date</span>
                            <p className="text-sm font-semibold text-teal-300 mt-1">
                              {formatDate(booking.bookingDate)}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="text-center py-8 text-teal-300/70">
                      No bookings found for this dealer
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Modal Footer */}
            <div className="flex items-center justify-end gap-3 p-4 sm:p-6 border-t border-teal-500/20 bg-slate-900/50 flex-shrink-0">
              <button
                onClick={closeModal}
                className="px-4 sm:px-6 py-2 sm:py-2.5 rounded-lg bg-teal-500/20 border border-teal-500/30 text-teal-300 hover:bg-teal-500/30 transition-all font-medium text-sm"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CommissionDealers;